import { MediaQuery } from 'utils/media_query';
import 'components/user/avatar';
import 'components/user_panel_menu_content';
import 'styles/components/_badges.scss';
import './index.scss';

const init = () => {
  const $body = $('body');

  $(document)
    .off('change.user-menu-mobile-toggle-input')
    .on('change.user-menu-mobile-toggle-input', '#user-menu-mobile-toggle-input', e => {
      if (MediaQuery.is('lt_header_lg_breakpoint')) {
        const { checked } = e.currentTarget;

        if (checked) {
          $('#segments-toggle-input').prop('checked', false);
          $body.addClass('q-no-scroll q-mobile-menu-open');
        } else {
          $body.removeClass('q-no-scroll q-mobile-menu-open');
        }
      }
    });

  (function _bindClose() {
    $('.q-user-menu--mobile, .q-segments-menu--mobile')
      .find('.q-user-menu-mobile-menu-close')
      .on('click', () => {
        $('#user-menu-mobile-toggle-input').prop('checked', false);
        $('#segments-toggle-input').prop('checked', false);
        $body.removeClass('q-no-scroll q-mobile-menu-open');
      });
  })();
};

document.addEventListener('turbolinks:load', () => init());
init();
